var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 3.49996V3.03329C9.33333 2.3799 9.33333 2.0532 9.20617 1.80364C9.09432 1.58411 8.91584 1.40564 8.69632 1.29379C8.44676 1.16663 8.12006 1.16663 7.46667 1.16663H6.53333C5.87994 1.16663 5.55324 1.16663 5.30368 1.29379C5.08416 1.40564 4.90568 1.58411 4.79383 1.80364C4.66667 2.0532 4.66667 2.3799 4.66667 3.03329V3.49996M1.75 3.49996H12.25M11.0833 3.49996V10.0333C11.0833 11.0134 11.0833 11.5034 10.8926 11.8778C10.7248 12.2071 10.4571 12.4748 10.1278 12.6426C9.75347 12.8333 9.26342 12.8333 8.28333 12.8333H5.71667C4.73657 12.8333 4.24653 12.8333 3.87218 12.6426C3.5429 12.4748 3.27518 12.2071 3.10741 11.8778C2.91667 11.5034 2.91667 11.0134 2.91667 10.0333V3.49996",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a04df35f627bc9e1bf7157bfb78a03c2.svg";
export { ForwardRef as ReactComponent };